import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE3Items = getItem('FE3', 'FE3', <FolderOutlined />, [
  getItem('1-1: Marth Embarks (Hidden)', 'FE3/11MarthEmbarksHidden'),
  getItem('1-10: The Ageless Palace (Hidden)', 'FE3/110TheAgelessPalaceHidden'),
  getItem('1-10: The Ageless Palace (Start)', 'FE3/110TheAgelessPalaceStart'),
  getItem('1-11: Land of Sorrow (Hidden)', 'FE3/111LandofSorrowHidden'),
  getItem('1-11: Land of Sorrow (Start)', 'FE3/111LandofSorrowStart'),
  getItem('1-12: An Oasis of Magic (Start)', 'FE3/112AnOasisofMagicStart'),
  getItem('1-13: The Battle for Altea (Hidden)', 'FE3/113TheBattleforAlteaHidden'),
  getItem('1-13: The Battle for Altea (Start)', 'FE3/113TheBattleforAlteaStart'),
  getItem('1-14: Star and Savior (Hidden)', 'FE3/114StarandSaviorHidden'),
  getItem('1-14: Star and Savior (Start)', 'FE3/114StarandSaviorStart'),
  getItem('1-15: Manakete Princess (Hidden)', 'FE3/115ManaketePrincessHidden'),
  getItem('1-15: Manakete Princess (Start)', 'FE3/115ManaketePrincessStart'),
  getItem('1-16: Camus the Sable (Hidden)', 'FE3/116CamustheSableHidden'),
  getItem('1-16: Camus the Sable (Start)', 'FE3/116CamustheSableStart'),
  getItem('1-17: A Knight-Filled Sky (Hidden)', 'FE3/117AKnightFilledSkyHidden'),
  getItem('1-17: A Knight-Filled Sky (Start)', 'FE3/117AKnightFilledSkyStart'),
  getItem('1-18: Dark Pontifex (Hidden)', 'FE3/118DarkPontifexHidden'),
  getItem('1-18: Dark Pontifex (Start)', 'FE3/118DarkPontifexStart'),
  getItem('1-19: The Dragonkin Realm (Hidden)', 'FE3/119TheDragonkinRealmHidden'),
  getItem('1-19: The Dragonkin Realm (Start)', 'FE3/119TheDragonkinRealmStart'),
  getItem('1-2: The Pirates of Galder (Hidden)', 'FE3/12ThePiratesofGalderHidden'),
  getItem('1-2: The Pirates of Galder (Start)', 'FE3/12ThePiratesofGalderStart'),
  getItem('1-20: Chosen', 'FE3/120Chosen'),
  getItem('1-3: A Brush in The Teeth (Hidden)', 'FE3/13ABrushinTheTeethHidden'),
  getItem('1-3: A Brush in The Teeth (Start)', 'FE3/13ABrushinTheTeethStart'),
  getItem('1-4: Champion of Aurelis (Hidden)', 'FE3/14ChampionofAurelisHidden'),
  getItem('1-4: Champion of Aurelis (Start)', 'FE3/14ChampionofAurelisStart'),
  getItem('1-5: Fire Emblem (Hidden)', 'FE3/15FireEmblemHidden'),
  getItem('1-5: Fire Emblem (Start)', 'FE3/15FireEmblemStart'),
  getItem('1-6: Lefcandith Gauntlet (Hidden)', 'FE3/16LefcandithGauntletHidden'),
  getItem('1-6: Lefcandith Gauntlet (Start)', 'FE3/16LefcandithGauntletStart'),
  getItem('1-7: Port Warren (Hidden)', 'FE3/17PortWarrenHidden'),
  getItem('1-7: Port Warren (Start)', 'FE3/17PortWarrenStart'),
  getItem('1-8: Princess Minerva (Hidden)', 'FE3/18PrincessMinervaHidden'),
  getItem('1-8: Princess Minerva (Start)', 'FE3/18PrincessMinervaStart'),
  getItem('1-9: Knorda Slave Market (Hidden)', 'FE3/19KnordaSlaveMarketHidden'),
  getItem('1-9: Knorda Slave Market (Start)', 'FE3/19KnordaSlaveMarketStart'),
  getItem('2-1: The Grustian Expedition (Hidden)', 'FE3/21TheGrustianExpeditionHidden'),
  getItem('2-1: The Grustian Expedition (Start)', 'FE3/21TheGrustianExpeditionStart'),
  getItem('2-10: Two Sorcerers (Hidden)', 'FE3/210TwoSorcerersHidden'),
  getItem('2-10: Two Sorcerers (Start)', 'FE3/210TwoSorcerersStart'),
  getItem('2-11: Anri\'s Way (Start)', 'FE3/211AnrisWayStart'),
  getItem('2-12: Graveyard of Fire Dragons (Start)', 'FE3/212GraveyardofFireDragonsStart'),
  getItem('2-13: Frozen Land (Start)', 'FE3/213FrozenLandStart'),
  getItem('2-14: A Mystery Revealed (Hidden)', 'FE3/214AMysteryRevealedHidden'),
  getItem('2-14: A Mystery Revealed (Start)', 'FE3/214AMysteryRevealedStart'),
  getItem('2-15: Return of the Prince (Hidden)', 'FE3/215ReturnofthePrinceHidden'),
  getItem('2-15: Return of the Prince (Start)', 'FE3/215ReturnofthePrinceStart'),
  getItem('2-16: Regaining the Capital (Hidden)', 'FE3/216RegainingtheCapitalHidden'),
  getItem('2-16: Regaining the Capital (Start)', 'FE3/216RegainingtheCapitalStart'),
  getItem('2-17: Gra\'s Sun Sets (Hidden)', 'FE3/217GrasSunSetsHidden'),
  getItem('2-17: Gra\'s Sun Sets (Start)', 'FE3/217GrasSunSetsStart'),
  getItem('2-18: Battle of the Pass (Start)', 'FE3/218BattleofthePassStart'),
  getItem('2-19: The Last Decisive Battle (Hidden)', 'FE3/219TheLastDecisiveBattleHidden'),
  getItem('2-19: The Last Decisive Battle (Start)', 'FE3/219TheLastDecisiveBattleStart'),
  getItem('2-2: Rebellion at Macedon (Hidden)', 'FE3/22RebellionatMacedonHidden'),
  getItem('2-2: Rebellion at Macedon (Start)', 'FE3/22RebellionatMacedonStart'),
  getItem('2-20: Dark Emperor (Hidden)', 'FE3/220DarkEmperorHidden'),
  getItem('2-20: Dark Emperor (Start)', 'FE3/220DarkEmperorStart'),
  getItem('2-21: The Wyvern\'s Dale (Start)', 'FE3/221TheWyvernsDaleStart'),
  getItem('2-3: Abducted Princess (Hidden)', 'FE3/23AbductedPrincessHidden'),
  getItem('2-3: Abducted Princess (Start)', 'FE3/23AbductedPrincessStart'),
  getItem('2-4: Joy and Sorrow (Hidden)', 'FE3/24JoyandSorrowHidden'),
  getItem('2-4: Joy and Sorrow (Start)', 'FE3/24JoyandSorrowStart'),
  getItem('2-5: Liberation of Grust (Hidden)', 'FE3/25LiberationofGrustHidden'),
  getItem('2-5: Liberation of Grust (Start)', 'FE3/25LiberationofGrustStart'),
  getItem('2-6: The Nest of Evil (Hidden)', 'FE3/26TheNestofEvilHidden'),
  getItem('2-6: The Nest of Evil (Start)', 'FE3/26TheNestofEvilStart'),
  getItem('2-7: The Scarlet Swordsman (Hidden)', 'FE3/27TheScarletSwordsmanHidden'),
  getItem('2-7: The Scarlet Swordsman (Start)', 'FE3/27TheScarletSwordsmanStart'),
  getItem('2-8: Soulful Bridge (Hidden)', 'FE3/28SoulfulBridgeHidden'),
  getItem('2-8: Soulful Bridge (Start)', 'FE3/28SoulfulBridgeStart'),
  getItem('2-9: Sanctuary of Sorcery (Hidden)', 'FE3/29SanctuaryofSorceryHidden'),
  getItem('2-9: Sanctuary of Sorcery (Start)', 'FE3/29SanctuaryofSorceryStart'),
  getItem('Arena Weapon Editor', 'FE3/ArenaWeaponEditor'),
  getItem('Buried Treasure Editor', 'FE3/BuriedTreasureEditor'),
  getItem('Chest Item Editor', 'FE3/ChestItemEditor'),
  getItem('Chest Item Editor 2', 'FE3/ChestItemEditor2'),
  getItem('Chest Item Editor 3', 'FE3/ChestItemEditor3'),
  getItem('Chest Item Editor 4', 'FE3/ChestItemEditor4'),
  getItem('Death Quote Editor', 'FE3/DeathQuoteEditor'),
  getItem('Debug Map (Start)', 'FE3/DebugMapStart'),
  getItem('Dragon\'s Table: Part 1 (Start)', 'FE3/DragonsTablePart1Start'),
  getItem('Dragon\'s Table: Part 2 (Start)', 'FE3/DragonsTablePart2Start'),
  getItem('Dragon\'s Table: Part 3 (Hidden)', 'FE3/DragonsTablePart3Hidden'),
  getItem('Dragon\'s Table: Part 3 (Start)', 'FE3/DragonsTablePart3Start'),
  getItem('Enemy Recrutable Character Editor', 'FE3/EnemyRecrutableCharacterEditor'),
  getItem('Event Tile Editor', 'FE3/EventTileEditor'),
  getItem('FE3 Army Editor', 'FE3/ArmyEditor'),
  getItem('FE3 Astral Shard Editor', 'FE3/AstralShardEditor'),
  getItem('FE3 Axe Lock Editor', 'FE3/AxeLockEditor'),
  getItem('FE3 Bow Lock Editor', 'FE3/BowLockEditor'),
  getItem('FE3 Chapter Enemy Sprite Editor', 'FE3/ChapterEnemySpriteEditor'),
  getItem('FE3 Character Growth & Base Editor', 'FE3/CharacterGrowthBaseEditor'),
  getItem('FE3 Class Bases Editor', 'FE3/ClassBasesEditor'),
  getItem('FE3 Class Growth Editor', 'FE3/ClassGrowthEditor'),
  getItem('FE3 Dragon Whip Check Editor', 'FE3/DragonWhipCheckEditor'),
  getItem('FE3 Dragonstone Lock Editor', 'FE3/DragonstoneLockEditor'),
  getItem('FE3 Item Editor', 'FE3/ItemEditor'),
  getItem('FE3 Knight Crest Check Editor', 'FE3/KnightCrestCheckEditor'),
  getItem('FE3 Lady Sword Lock Editor', 'FE3/LadySwordLockEditor'),
  getItem('FE3 Lance Lock Editor', 'FE3/LanceLockEditor'),
  getItem('FE3 Orb Fragment Editor', 'FE3/OrbFragmentEditor'),
  getItem('FE3 Promotion Editor', 'FE3/PromotionEditor'),
  getItem('FE3 Promotion Items Editor', 'FE3/PromotionItemsEditor'),
  getItem('FE3 Resire Lock Editor', 'FE3/ResireLockEditor'),
  getItem('FE3 Shop Contents Editor', 'FE3/ShopContentsEditor'),
  getItem('FE3 Shop Editor', 'FE3/ShopEditor'),
  getItem('FE3 Stave Lock Editor', 'FE3/StaveLockEditor'),
  getItem('FE3 Sword Lock Editor', 'FE3/SwordLockEditor'),
  getItem('FE3 Tome Lock Editor', 'FE3/TomeLockEditor'),
  getItem('Map Data Editor', 'FE3/MapDataEditor'),
  getItem('Support Editor', 'FE3/SupportEditor'),
  getItem('Universal Reinforcements', 'FE3/UniversalReinforcements'),
]);

export default FE3Items;
